import { FilterChip, FilterList, FilterPopover } from "@amzn/stencil-react-components/filtering";
import { Row, Spacer } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { IconFilterExtraSmall, IconSortExtraSmall } from "@amzn/stencil-react-icons";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

import { UseCaseBrowseTouchpoint } from "../constants";

interface BrowseFiltersProps {
  jobFamilies: { label: string; value: string }[];
  categories: { label: string; value: string }[];
  selectedJobFamilies: string[];
  selectedCategories: string[];
  sortBy: string;
  defaultSortLabel: string;
  sortOptions: { label: string; value: string }[];
  onJobFamilyChange: (selection: unknown) => void;
  onCategoriesChange: (selection: unknown) => void;
  onSortChange: (selection: unknown) => void;
}

export const BrowseFilters: FC<BrowseFiltersProps> = ({
  jobFamilies,
  categories,
  selectedJobFamilies,
  selectedCategories,
  sortBy,
  defaultSortLabel,
  sortOptions,
  onJobFamilyChange,
  onCategoriesChange,
  onSortChange,
}) => (
  <Row className="use-case-browse-page__filters" justifyContent="space-between" alignItems="center">
    <Row alignItems="center" gridGap="S200">
      <Row alignItems="center" gridGap="S100">
        <IconFilterExtraSmall color="neutral90" />
        <Text style={{ whiteSpace: "nowrap" }}>{getString("useCases.browsePage.filterBy")}</Text>
      </Row>
      <FilterPopover
        triggerComponent={<FilterChip>{getString("useCases.browsePage.filterJobFamily")}</FilterChip>}
        data-cy={UseCaseBrowseTouchpoint.FilterJobFamily}
      >
        <FilterList
          isMulti
          isSearchable
          titleText={getString("useCases.browsePage.filterJobFamily")}
          options={jobFamilies}
          value={selectedJobFamilies}
          onFilterChange={onJobFamilyChange}
        />
      </FilterPopover>
      <FilterPopover
        triggerComponent={<FilterChip>{getString("useCases.browsePage.filterCategories")}</FilterChip>}
        data-cy={UseCaseBrowseTouchpoint.FilterCategories}
      >
        <FilterList
          isMulti
          isSearchable
          titleText={getString("useCases.browsePage.filterCategories")}
          options={categories}
          value={selectedCategories}
          onFilterChange={onCategoriesChange}
        />
      </FilterPopover>
    </Row>

    <Row alignItems="center" gridGap="S100">
      <IconSortExtraSmall color="neutral90" />
      <Text style={{ whiteSpace: "nowrap" }}>{getString("useCases.browsePage.sortBy")}</Text>
      <Spacer width="S100" />
      <FilterPopover
        triggerComponent={
          <span style={sortBy !== defaultSortLabel ? { fontWeight: "bold" } : undefined}>
            <FilterChip>{sortBy}</FilterChip>
          </span>
        }
        data-cy={UseCaseBrowseTouchpoint.Sort}
      >
        <FilterList
          titleText={getString("useCases.browsePage.sortBy")}
          options={sortOptions}
          value={sortBy}
          onFilterChange={onSortChange}
        />
      </FilterPopover>
    </Row>
  </Row>
);
